import axios from "axios";


export const fetchLabEnteryCall = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Lab/SampleCollection
    `);
  };

  export const fetchLabEnteryPrintCall = (id) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Lab/${id}/print`, {
      responseType: 'blob',
    });
  };